import { useRef, useState } from "react";

import { IconButton, TextField, Typography } from "@mui/material";
import classNames from "classnames";
import moment from "moment";
import { IoSend } from "react-icons/io5";
import { Link } from "react-router-dom";

import { useAccount } from "../../../../hooks/useAccount";
import { RichTypography } from "../../../common/RichTypography/RichTypography";
import { useLearning } from "../hooks/useLearning";
import { useLearningMessage } from "../hooks/useLearningMessage";

export function Message() {
	const { teacher } = useLearning();
	const { messages, splitMessageAndSend } = useLearningMessage();
	const { account } = useAccount();
	const [text, setText] = useState("");
	const prevKeyCode = useRef("");

	const onClickSendMessage = () => {
		if (!text) {
			return;
		}

		const body = {
			body: text.trim(),
			receiverId: teacher?.userId ?? "",
		};

		splitMessageAndSend(body);
		setText("");
	};

	return (
		<div className="item-separator-big">
			<div className="messages">
				{messages?.map((message) => (
					<div
						className={classNames("message-item", {
							"my-message": message.senderId === account?.id,
						})}
						key={message.messageId}>
						<Link
							className="normal-text bold no-underline-link user-name"
							to={`/profile/${message.sender.profile?.profileSlug ?? ""}`}>
							{`${message.sender.firstName ?? ""} ${message.sender.lastName ?? ""}`.trim()}
						</Link>
						<Typography component="span" className="sent-time">
							{moment(message.createdAt).format("HH:mm, DD MMM, YYYY")}
						</Typography>
						<RichTypography
							whiteSpace="break-spaces"
							text={message.message}
							id={message.messageId}
							className="normal-text"
						/>
					</div>
				))}
			</div>
			<div
				className={classNames("input-box", {
					"item-separator-small": messages.length > 0,
				})}>
				<TextField
					fullWidth
					variant="standard"
					multiline
					style={{ height: "calc(100% - 2px)", overflowY: "auto" }}
					placeholder="Feel free to type a message or ask a question..."
					value={text}
					onChange={(event) => {
						setText(event.target.value);
					}}
					slotProps={{
						input: {
							disableUnderline: true,
							className: "normal-text",
						},
					}}
					onKeyDown={(event) => {
						if (
							event.code === "Enter" &&
							(prevKeyCode.current === "ShiftLeft" ||
								prevKeyCode.current === "ShiftRight")
						) {
							event.preventDefault();
							onClickSendMessage();
						}
						prevKeyCode.current = event.code;
					}}
				/>
				<IconButton
					type="submit"
					disabled={text.trim() === ""}
					onClick={onClickSendMessage}>
					<IoSend
						className={classNames("normal-icon send-icon", {
							disabled: text.trim() === "",
						})}
					/>
				</IconButton>
			</div>
		</div>
	);
}
